// BT-112051 Creating tabs in Scrip Overview Analysis : ManasaB : 27/06/2023 - Start
import { memo, useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Container } from "react-bootstrap";
import SupportResistance from "./SupportResistance";
import SimpleMovingAverages from "./SimpleMovingAverages";
import { SUPPORT_RESISTANCE_VIEW, WATCHLIST_GRID_INDEX, TL_INDEX, MARKET_SEGMENT_ID } from "../../utils/global_variables";
import { createChartUrl, calculateSupportRestistanceValues, sendDataToChart, convertDateToSeconds } from "../../utils/global_functions";
import { BzToolTip } from "../../components";
import { GetContractDetails, getMarketMovementInfo, getSecurityDetails } from "../../redux/actions/marketOverview";
import { useWFHMessages } from "../../hooks";
import OverviewChart from "../MarketOverview/OverviewChart";
import { scripoverviewMarketMovement } from "../../apis/nontransactional";
import { convertIntradayData } from "../../controllers/analysis";
import LineChart from "./LineChart";
import ZeroStates from "../ZeroStates";

const Technical = ({ expandScripOverviewModel, isVertical = true }) => {
  const dispatch = useDispatch();
  const [apiCalled, setApiCalled] = useState({ called: false, isDataPresent: false });
  const chartAttributes = useSelector((state) => state.appInfo.chartAttributes);
  const scripOverviewData = useSelector((state) => state.marketOverview.scripOverviewData);
  const securityDetails = useSelector(state => state?.marketOverview?.securityDetails);
  const objContractCodeInfo = useSelector(state => state.marketOverview.objContractCodeInfo);
  const [lineData, setLineData] = useState([]);
  const [selectTimeInterval, setSelectTimeInterval] = useState(30); // Hari k:23-05-2024: changes chart intervals
  const analysisChartUrl = createChartUrl(
    scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID],
    scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
    chartAttributes
  );
  const handleApi = useCallback(async () => {
    let temp = await scripoverviewMarketMovement({
      MktSegId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
      Token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
      Records: 260,
    });
    let data = temp.data.result.flatMap(x => (x?.length > 0 ? convertIntradayData(x) : []));

    data = data.map(x => {
      return {
        time: Number(x?.time),
        value: x?.close,
        open: x?.open,
        high: x?.high,
        low: x?.low,
        close: x?.close,
        volume: Number(x.volume) || 0,
      }})
      .sort((a, b) => a.time - b.time)
      .filter((item, index, arr) => index === 0 || item.time > arr[index - 1].time);

    setLineData(data);
    setApiCalled(() => { return { called: true, isDataPresent: data?.length > 0 } })
  }, [scripOverviewData]);


  useEffect(() => {
    if (lineData?.length === 0 && !apiCalled?.called) {
      handleApi();
    }
  }, [apiCalled, handleApi, lineData]);
  //Vaibhav SIngh : BT-117493 : 13-09-2023 : added touchline in technical
  useWFHMessages('touchline', (e) => {
    if (scripOverviewData?.length) {
      if (e.detail[TL_INDEX.TOKEN] === scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN]) {
        sendDataToChart(e.detail, scripOverviewData);
      }
    }
  });

  const [supportResistance, setSupportResistance] = useState({});
  //Vaibhav Singh:15-12-23: uncommented code of chart and support dependency updated: Start
  useEffect(() => {
    if (scripOverviewData?.length !== 0) {
      const objMarketMovementPaylod = {
        MktSegId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
        Token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
        TimeInterval: parseInt(selectTimeInterval)
      };
      const decimalLocator = scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
      const decimalLocatorLength = scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH];
      dispatch(getMarketMovementInfo(objMarketMovementPaylod, decimalLocator, decimalLocatorLength));
      dispatch(getSecurityDetails({ mktSegmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN] : scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] }));
    } else { }
  }, [dispatch, scripOverviewData, selectTimeInterval]);

  useEffect(() => {
    if (scripOverviewData.length !== 0) {
      if (scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_CASH || scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_CASH || scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.MSX_CASH || scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.OFS_IPO_BONDS) {
        const marketSupportResistanceData = securityDetails?.pivot?.length ? { PrevClose: securityDetails?.pivot[0]?.PrevClose, PrevHigh: securityDetails?.pivot[0]?.PrevHigh, PrevLow: securityDetails?.pivot[0]?.PrevLow, PrevOpen: securityDetails?.pivot[0]?.PrevOpen } : {};
        //Vaibhav Singh: 06-12-23: BT-109089: Added page Flag: Start
        const resitancePivotObj = calculateSupportRestistanceValues(marketSupportResistanceData, 'Classic', '(H+L+C)/3', scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], true);
        //Vaibhav Singh: 06-12-23: BT-109089: Added page Flag: End
        setSupportResistance(resitancePivotObj);
      } else {
        dispatch(GetContractDetails({ mktSegmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], expDate: convertDateToSeconds(scripOverviewData[WATCHLIST_GRID_INDEX.EXPIRYDATE]), symbol: scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL], instName: scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT], strkPrice: (scripOverviewData[WATCHLIST_GRID_INDEX.STRIKEPRICE]) === '' ? '-1' : (parseFloat(scripOverviewData[WATCHLIST_GRID_INDEX?.STRIKEPRICE]) * scripOverviewData[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR]), optType: scripOverviewData[WATCHLIST_GRID_INDEX?.OPTIONTYPE] }));
      }
    } else { }
  }, [dispatch, scripOverviewData, securityDetails]);

  useEffect(() => {
    if (scripOverviewData.length !== 0 && objContractCodeInfo) {
      const marketSupportResistanceData = Object.keys(objContractCodeInfo?.highlowclose)?.length ? { PrevClose: objContractCodeInfo?.highlowclose?.PrevClose, PrevHigh: objContractCodeInfo?.highlowclose?.PrevHigh, PrevLow: objContractCodeInfo?.highlowclose?.PrevLow, PrevOpen: objContractCodeInfo?.highlowclose?.PrevOpen } : {};
      //Vaibhav Singh: 06-12-23: BT-109089: Added page Flag: Start
      const resitancePivotObj = calculateSupportRestistanceValues(marketSupportResistanceData, 'Classic', '(H+L+C)/3', scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], true);
      //Vaibhav Singh: 06-12-23: BT-109089: Added page Flag: End
      setSupportResistance(resitancePivotObj);
    } else { }
  }, [objContractCodeInfo, scripOverviewData]);

  //Vaibhav Singh:15-12-23: uncommented code of chart dependency updated: End
  const [isExpand, setIsExpand] = useState(false);
  const handleExpand = () => {
    setIsExpand(!isExpand);
  };
  return (
    <>
      {(isVertical) ?
        <><Container data-testid="market-overview-analysis-technical-chart-section" fluid className='p-0 mt-5'>
          <div className='scripoverview-fieldset'>
            <div className={`${isExpand ? 'scripoverview-fieldset-xl' : 'p-0'}`}>
              <div className='scripoverview-legend'>CHART</div>

              {(isExpand) ?
                <OverviewChart className='scripoverview-chart' handleClose={handleExpand} chartUrl={analysisChartUrl} isExpand={expandScripOverviewModel} setIsExpand={setIsExpand} />
                : apiCalled?.called ? apiCalled?.isDataPresent ?
                  <LineChart className='scripoverview-chart' lineData={lineData} isExpand={expandScripOverviewModel} />
                  :
                  <Row className='g-0'>
                    <Col md={6} className='mrgauto'>
                      <div className='zero-state-alerts zero-state-alerts-lg'>
                        <ZeroStates subText="" isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                        <div className='font-regular font-size2 color-nodata'>Something went wrong.</div>
                        <div className='font-regular font-size2 color-nodata'>Let us fix the problem and get back to you soon. Meanwhile try</div>
                        <div className='font-regular font-size2 color-nodata'><span className='color-primary cursor-pointer'>Refreshing the page</span> or come back later.</div>
                      </div>
                    </Col>
                  </Row> : null}

              {!isExpand ?
                <div className='fixed-icons-wrapper'>
                  <div className='d-flex justify-content-end align-items-center'>
                    <div className='background-icon' onClick={handleExpand}>
                      <BzToolTip placement={isExpand ? 'left' : 'top'} TooltipMsg={isExpand ? 'Collapse' : 'Expand'}><div data-testid="market-overview-analysis-technical-expand-icon" className={`icon-16 icon-dark ${isExpand ? "icon-collapse" : "icon-expand"}`}></div></BzToolTip>
                    </div>
                  </div>
                </div>
                : null}

            </div>
          </div>
        </Container>

          {!isExpand ?
            <Row className='g-0 mt-5'>
              <Col className='pe-3'>
                <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.SCRIP_OVERVIEW} />
              </Col>
              <Col className='ps-3'>
                <SimpleMovingAverages />
              </Col>
            </Row> : null}
        </>
        :
        <>
          {!isExpand ?
            <>
              <Row className='g-0'>
                <Col>
                  <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.SIDETRAY_SCRIP_OVERVIEW} />
                </Col>
              </Row>
              <Row>
                <Col className='ps-3'>
                  <SimpleMovingAverages isVertical={isVertical} />
                </Col>
              </Row>
            </>
            : null}
        </>
      }
    </>
  );
};

export default memo(Technical);
// BT-112051 Creating tabs in Scrip Overview Analysis : ManasaB : 27/06/2023 - End
